(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moonstruck-style-products')) {
    customElements.define('moonstruck-style-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const list = this.querySelector('[data-style-product-list]');
        if (!list) return;
        const cards = Array.from(list.children);
        for (let i = cards.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        const limit = Math.max(1, Number(this.dataset.limit) || 4);
        list.replaceChildren(...cards.slice(0, limit));
        this.dataset.ready = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
